export const environment = {
    production: true,
    local: false,
    version: '1.1.0', //packageInfo.version,
    footerUrl: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/template/rodapeSigepe/text',
    menuUrl: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/menu-sigepe',
    mensageriaUrl: 'https://ca-mensageiria.sigepe.gov.br/sigepe-ca-mensageiria-web/private/leitor.jsf',
    manualUrl: 'https://bgp.sigepe.gov.br/sigepe-bgp-web-intranet/pages/manual/consultar.jsf',
    sistemaOrigem: 'FERIAS',
    menuAddFromRouter: true,
    menuIgnoreRouterGuard: false,
    loginUnicoHost: 'https://sso.acesso.gov.br',
    jwksHost: '',
    apiSigepeHost: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/seguranca',
    apiSigepeURL: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/',
    clientId: 'sigepe.gov.br',
    cookieDomain: '.sigepe.gov.br',
    barramentoServicoFerias: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/ferias-v2',
    analyticsSettings: {
        trackingCode: 'G-XXXXXXXXX'
    },
    avaliacaoFuncionalidadeConfiguration: {
        urlApi: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/pesquisa-avaliacao/avaliacao-servico/v1/'
    }
};
